module.exports = __webpack_public_path__ + "img/21.94359d50.jpg";